import type { CellContext } from '@tanstack/react-table'
import { LoaderIcon } from 'lucide-react'

import { TableSelectRowCheckbox } from '@/components/ui'
import { isProjectBusy } from '@/modules/projects/status'
import type { Project } from '@/modules/projects/stores/types'

export const SelectCell = (cell: CellContext<Project, unknown>) => {
  if (isProjectBusy(cell.row.original)) {
    return (
      <span className="flex items-center" title="Processing">
        <LoaderIcon className="size-4 text-muted-foreground/50" />
      </span>
    )
  }
  return <TableSelectRowCheckbox row={cell.row} />
}
